import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  &.red path, &.red rect {
    fill: ${({ theme }) => theme.colors.errorRed}
  }
`;

export const DeleteIcon = (props) => (
  <SVG {...props} viewBox="0 0 24 24">
    <g stroke="" strokeWidth=".4">
      <path d="M20,3.92H15.9V3.18A1.78,1.78,0,0,0,14.12,1.4H9.92A1.78,1.78,0,0,0,8.14,3.18v.74H4a.1.1,0,0,0-.1.1v.84A.1.1,0,0,0,4,5h.74l.77,15.55a2.2,2.2,0,0,0,2.2,2.09h8.53a2.2,2.2,0,0,0,2.2-2.09L19.26,5H20a.1.1,0,0,0,.1-.1V4A.1.1,0,0,0,20,3.92ZM9.92,2.44h4.2a.74.74,0,0,1,.74.74v.74H9.18V3.18A.74.74,0,0,1,9.92,2.44Zm8.35,2.42h0Zm-2,16.7H7.76a1.16,1.16,0,0,1-1.16-1.1L5.82,5H18.21l-.77,15.5A1.16,1.16,0,0,1,16.28,21.56Z" />
      <rect x="11.5" y="6.44" width="1.04" height="13.64" rx="0.1" ry="0.1" />
      <path d="M15.8,6.44H15a.1.1,0,0,0-.1.09L14,20A.1.1,0,0,0,14,20a.1.1,0,0,0,.07,0H15a.1.1,0,0,0,.1-.09L15.9,6.56a.08.08,0,0,0,0,0A.1.1,0,0,0,15.8,6.44Zm0,.1h0l0,.74Zm-1.63,12.7,0,.74h0Z" />
      <path d="M9.08,6.44H8.24a.1.1,0,0,0-.07,0,.1.1,0,0,0,0,.07L9,20a.1.1,0,0,0,.1.09h.84A.1.1,0,0,0,10,20,.1.1,0,0,0,10,20L9.18,6.53A.1.1,0,0,0,9.08,6.44Z" />
    </g>
  </SVG>
);

export default DeleteIcon;
